"use client";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { SpaceXxs, ColorGray600 } from "@nxt-costco-com/forge-design-tokens";
const StyledContainer = styled("li")({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  gap: SpaceXxs,
  justifyContent: "flex-start"
});
const StyledImage = styled("img")({
  height: "64px",
  width: "64px"
});
const StyledImagePlaceholder = styled(Box)({
  border: `1px dashed ${ColorGray600}`,
  height: "64px",
  width: "64px"
});
export {
  StyledContainer,
  StyledImage,
  StyledImagePlaceholder
};
